import axios from 'axios';
export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        $cancelRequest() {
          return axios.CancelToken.source();
        }
      }
    });
  }
};
